import React, { Component } from 'react';
import classNames from 'classnames';
import Clamp from 'shiitake';
import { pickBy, negate, isNull } from 'lodash/fp';
import CornerRibbon from 'components/_shared/corner_ribbon.js';
import { setQueryString } from 'utils/url';
import CoverImage from './CoverImage';

const pickNonNull = pickBy(negate(isNull)); // remove keys with null values

class LibraryTopic extends Component {
  get featured() {
    return this.props.topic.library_visibility === 'featured_in_library';
  }

  render() {
    const { topic, filters, onClick, ...props } = this.props;
    const className = classNames('LibraryTopic CustomColor--borderColorLeft', {
      'LibraryTopic--withImage': !!topic.image,
      [props.className]: props.className,
    });
    return (
      <a
        className={className}
        href={setQueryString(topic.path, pickNonNull(filters))}
        onClick={onClick}
      >
        {this.featured && <CornerRibbon type="warning" icon="star_filled" />}
        {topic.image && <CoverImage image={topic.image} />}
        <div className="LibraryTopic-content d-f jc-sb fd-c">
          <div>
            <Title lines={3}>{topic.name}</Title>
            {topic.description && (
              <Description lines={4}>{topic.description}</Description>
            )}
          </div>
          <div className="LibraryTopic-count">{topic.content_counts_text}</div>
        </div>
      </a>
    );
  }
}

const Title = props => (
  <Clamp tagName="h3" className="LibraryTopic-title" {...props} />
);

const Description = props => (
  <Clamp tagName="p" className="LibraryTopic-description" {...props} />
);

export default LibraryTopic;
